import { css } from "styled-components";

/**
 * New look: the users list's row grid - chevron, avatar or logo, names,
 * figures, menu - shared by user, slot and account rows so the tree reads in
 * straight columns. Phones drop the avatar column.
 */
export const newLookTreeRow = css`
  display: grid;
  grid-template-columns: 16px 32px minmax(0, 1fr) auto 32px;
  align-items: center;
  column-gap: 12px;
  padding: 6px 16px 6px 20px;
  @media (max-width: 400px) {
    grid-template-columns: 16px minmax(0, 1fr) auto 32px;
    column-gap: 10px;
    padding-left: 16px;
    padding-right: 8px;
    > :nth-child(2) {
      display: none;
    }
  }
`;
